import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class SystemEmailSettingsHelper  {
    _originalTypeClassName = "ekylikeio.BO.SystemEmailSettingsHelper";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
SystemEmailSettingsHelper.translate = translateService;
}
this.SystemEmailSettingsHelperKey = null;
this._key = this.SystemEmailSettingsHelperKey = 0; 
}

static translate: TranslateService;
_key: any;
private _SystemEmailSettingsHelperKey:any;
get SystemEmailSettingsHelperKey(): any {
    return this._SystemEmailSettingsHelperKey;
  }
set SystemEmailSettingsHelperKey(value: any) {
    this._SystemEmailSettingsHelperKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.SystemEmailSettingsHelperKey == null || $this.SystemEmailSettingsHelperKey == 0;
            }


}